module.exports = __webpack_public_path__ + "img/imgGift.58eaf9dc.png";